module.exports = __webpack_public_path__ + "99760c58f844a9f8d8e3079e01e68b7b.pdf";